var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"site-wrapper"},[_c('TheSidebar'),_c('el-container',{staticClass:"content-area-wrapper"},[_c('TheHeader'),_c('el-main',{staticClass:"main"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }